import React, { CSSProperties, ReactNode } from "react";
// External dependencies
import classnames from "classnames";
// Internal dependencies
import { generateMarginClasses, generatePaddingClasses } from "./MarginPaddingGenerator";

// Define prop types for Column and Row components
interface CommonProps {
  sm?: number;
  lg?: number;
  md?: number;
  xxl?: number;
  size?: number;
  sx?: CSSProperties;
  className?: string;
  children?: ReactNode;
  [key: string]: any; // This allows additional props to be spread
}

export const Column: React.FC<CommonProps> = ({
  sm,
  lg,
  md,
  xxl,
  size,
  sx,
  className,
  ...props
}) => {
  const { mt, mb, ml, mr, m } = props
  const marginClasses = generateMarginClasses({  mt, mb, ml, mr, m  }); // Spread margin props
  const paddingClasses = generatePaddingClasses({  mt, mb, ml, mr, m  }); // Spread padding props

  // Combining default and additional classes for the column class names
  const classNames = classnames({
    [`col-sm-${sm}`]: sm,
    [`col-lg-${lg}`]: lg,
    [`col-md-${md}`]: md,
    [`col-xxl-${xxl}`]: xxl,
    [`col-${size}`]: size,
    [marginClasses]: marginClasses,
    [paddingClasses]: paddingClasses,
    [className as string]: className,
  });

  const columnStyle: CSSProperties = sx ? { ...sx } : {};
  return (
    <div className={classNames} style={columnStyle}>
      {props.children}
    </div>
  );
};

export const Row: React.FC<CommonProps> = ({
  sm,
  lg,
  md,
  xxl,
  size,
  sx,
  className,
  ...props
}) => {
  const { mt, mb, ml, mr, m } = props;
  const marginClasses = generateMarginClasses({ mt, mb, ml, mr, m }); // Spread margin props
  const paddingClasses = generatePaddingClasses({ mt, mb, ml, mr, m }); // Spread padding props

  // Combining default and additional classes for the row class names
  const rowClass = classnames({
    row: true,
    [marginClasses]: marginClasses,
    [paddingClasses]: paddingClasses,
    [className as string]: className,
  });

  const columnStyle: CSSProperties = sx ? { ...sx } : {};
  return (
    <div className={rowClass} style={columnStyle}>
      {props.children}
    </div>
  );
};
